<script setup lang="ts">
import { useUserStore } from "@/stores/user";

const userStore = useUserStore();

const priorityOptions = [
  {
    value: "low",
    label: "Low",
  },
  {
    value: "medium",
    label: "Medium",
  },
  {
    value: "high",
    label: "High",
  },
];
</script>

<template>
  <fieldset class="flex max-w-max items-center justify-start gap-x-3 pl-2">
    <FormKit
      type="checkbox"
      name="priority"
      :options="priorityOptions"
      :value="['low', 'medium', 'high']"
      :classes="{
        options: 'flex flex-row gap-x-3',
        option: '!m-0',
      }"
    >
      <template #label="{ option }">
        <i
          class="fa-solid fa-fire-flame-simple pr-1 text-lg"
          :class="{
            'text-yellow-500': String(option.value) === 'low',
            'text-orange-400': String(option.value) === 'medium',
            'text-red-500': String(option.value) === 'high',
          }"
        ></i>
        <span class="font-semibold">{{ option.label }}</span>
      </template>
    </FormKit>
    <FormKit
      type="toggle"
      name="assignees"
      label="View My Tickets Only"
      :on-value="userStore.user?.user_id ? [userStore.user.user_id] : undefined"
      :off-value="undefined"
      :classes="{ wrapper: '!mb-0' }"
    />
  </fieldset>
</template>
